import { browserUtil, tokenService } from '../common'
import { EventBusActionType, EventBusEntityType, eventBusUtil } from '../util/auth-event-bus-util'
import React, { createContext, useCallback, useEffect, useState } from 'react'

export type AuthSessionData = {
  isLoading: boolean
  isLoggedIn: boolean
  redirectUrl: string | undefined
}
export const AuthSessionContext = createContext<AuthSessionData>({} as AuthSessionData)

export const AuthSessionContextProvider = ({ children }: { children: React.ReactElement }): React.ReactElement => {
  const [isLoading, setIsLoading] = useState(true)
  const [isLoggedIn, setIsLoggedIn] = useState(false)

  const [redirectUrl] = useState(getRedirectFromLocation())

  const checkIfLoggedIn = useCallback((): void => {
    setIsLoggedIn(tokenService.hasAccessToken())
  }, [])

  useEffect(() => {
    setIsLoading(true)
    checkIfLoggedIn()
    setIsLoading(false)

    const subscription = eventBusUtil().subscribe(
      { actions: [EventBusActionType.CREATE, EventBusActionType.REMOVE], entities: [EventBusEntityType.ACCESS_TOKEN] },
      async () => checkIfLoggedIn(),
    )
    return () => {
      subscription.unsubscribe()
    }
  }, [checkIfLoggedIn])

  return <AuthSessionContext.Provider value={{ isLoggedIn, isLoading, redirectUrl }}>{children}</AuthSessionContext.Provider>
}

const getRedirectFromLocation = (): string | undefined => {
  const url = new URL(browserUtil.location())
  const search = new URLSearchParams(url.search)
  return search.get('redirect') ?? undefined
}
